export const getGlobalPresetImpc = (state) => state.globalPreset.globalImpcPreset;
export const getGlobalPresetOperator = (state) => state.globalPreset.globalOperatorPreset;
